export default "__VITE_ASSET__Ci91yRLU__"